import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Client } from '../shared/models/client.model';
import { ClientContract, ClientGoal, ClientSearch, CountAndResults } from '../shared/types';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  private http = inject(HttpClient);


  add(client: Client): Observable<void> {
    return this.http.post<void>('/api/client', client);
  }

  search(body: ClientSearch): Observable<CountAndResults> {
    return this.http.post<CountAndResults>('/api/clients/search', body);
  }

  get(id: string): Observable<Client> {
    return this.http.get<Client>(`/api/client/${id}`);
  }

  update(client: Client): Observable<void> {
    return this.http.put<void>(`/api/client/${client._id}`, client);
  }

  delete(client: Client): Observable<void> {
    return this.http.delete<void>(`/api/client/${client._id}`);
  }

  addArrayField(client: Client, item: ClientContract | ClientGoal, field: 'contract' | 'goal'): Observable<void> {
    return this.http.post<void>(`/api/client/${client._id}/${field}`, item);
  }

  updateArrayField(client: Client, item: ClientContract | ClientGoal, field: 'contract' | 'goal'): Observable<void> {
    return this.http.put<void>(`/api/client/${client._id}/${field}`, item);
  }

  deleteArrayField(client: Client, itemId: number | string, field: 'contract' | 'goal'): Observable<void> {
    return this.http.delete<void>(`/api/client/${client._id}/${field}/${itemId}`);
  }

}
